(function($, Drupal, drupalSettings) {

  Drupal.behaviors.mba_text_list = {
    attach: function (context, settings) {

      $(window).on('load', function() {
        $('.paragraph--type--mba-text ul > li', context).once('mba-text-list-mbf-print').mbf_image_bg_print({
          browser: 'ie',
        });
      });

    }
  }; // Drupal.behaviors.mba_text_list

})(jQuery, Drupal, drupalSettings);